"use strict";
import React from "react";

window.jQuery = $;
var signalR = require('@microsoft/signalr');

const initComponent = (flex = window.flex) => {

    class SignalR extends React.PureComponent {
        connection = null;

        UNSAFE_componentWillMount() {
            this.wireUpSignalR();
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            let self = this;
            var signalRGroups = this.props.signalRGroups || [];
            var nextSignalRGroups = nextProps.signalRGroups || [];

            var currentGroupIds = _.union(signalRGroups.map(x => x.groupId), []);
            var nextGroupIds = _.union(nextSignalRGroups.map(x => x.groupId), []);

            if (!_.isEqual(currentGroupIds, nextGroupIds)) {
                self.subscribeToGroups(nextGroupIds);
            }
        }

        subscribeToGroups = (groups) => {
            if(this.connection && groups && groups.length > 0){
                this.connection.invoke("Subscribe", groups);            
            }
        };

        wireUpSignalR = () => {
            let self = this;
            const hubUrl = flex.getApiUrl('/api/v1/signalr/connect');
            const logLevel = signalR.LogLevel.Debug;

            this.connection = new signalR.HubConnectionBuilder()
                //.withUrl("https://localhost:7088/api/v1/signalr/connect")
                .withUrl(hubUrl, 
                    {
                        skipNegotiation: true,
                        transport: signalR.HttpTransportType.WebSockets
                    }
                )
                .configureLogging(logLevel)
                .withAutomaticReconnect()
                .build();

            this.connection.onreconnecting(error => {
                console.assert(this.connection.state === signalR.HubConnectionState.Reconnecting);

                flex.removePageAlerts('SignalR');
                self.consoleLogHelper('SignalR: OnConnecting');
            });

            this.connection.onreconnected(connectionId => {
                console.assert(this.connection.state === signalR.HubConnectionState.Connected);

                flex.removePageAlerts('SignalR');
                self.consoleLogHelper('SignalR: OnReconnected');
                this.initSubscribe();
            });

            this.connection.onclose(async (connectionId) => {
                console.assert(this.connection.state === signalR.HubConnectionState.Disconnected);

                flex.removePageAlerts('SignalR');
                self.consoleLogHelper('SignalR: OnClose');

                await this.start();
            });

            this.connection.on("notifyClient", (message, groupId) => {
                let signalRGroups = self.props.signalRGroups || [];
                let reaction = _.find(signalRGroups, function (o) {
                    return o.groupId === groupId
                });
                if (reaction) {
                    try{
                        let objMessage = (typeof message === 'string' || message instanceof String) ? JSON.parse(message) : message;
                        flex.trigger(reaction.triggerName, objMessage.Message, true);
                    } catch (err) {
                        console.log(err);
                    }                    
                }
            });

            this.start();
        };

        retryCount = 0;
        start = async () => {
            try {
                if(this.connection !== undefined){
                    await this.connection.start();
                    this.consoleLogHelper('SignalR: Connection starting');
                    flex.removePageAlerts('SignalR');
                    this.initSubscribe();
                }                
            } catch (err) {
                console.log(err);
                (this.retryCount++ <= 5) ? setTimeout(this.start, this.retryCount*5000) : null;
            }
        };

        consoleLogHelper = (message) => {
            console.log('%c' + message, 'color: blue; font-size: x-large');
        };

        render() {
            return <div>{this.props.children}</div>;
        }

        initSubscribe(){
            try{
                let signalRGroups = this.props.signalRGroups || [];
                let currentGroupIds = _.union(signalRGroups.map(x => x.groupId), []);
                this.consoleLogHelper('Subscribe To Group: ' + currentGroupIds);
                this.subscribeToGroups(currentGroupIds);
            } catch (err){
                console.log(err);
            }
        }
    }

    return SignalR;
}

module.exports = initComponent;